import { Component, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { Subject, Subscription } from 'rxjs/Rx';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap }  from '@angular/router';
import { Title, Meta }     from '@angular/platform-browser';

import { RestaurantProvider } from '../../providers/restaurant';

declare var google;

@Component({
    selector: 'page-location',
    templateUrl: './location.html',
    styleUrls: ['./location.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LocationPage {

	private locations = {
		flagler: {
			name: 'Flagler Beach, FL',
			img: 'assets/img/loc-flagler.jpg',
			geo: {
				latitude: 29.4780379,
				longitude: -81.1358302
			},
			radius: 50,
		}
	}

	private combSubject: Subject<any>;
	private restSub: Subscription;

	public location: any;
	public rests: Array<any> = [];

	private radius: any = 10;

	constructor (
		protected restProv: RestaurantProvider,
		private _fb: FormBuilder,
  	private titleService: Title,
  	private metaService: Meta,
  	private route: ActivatedRoute,
		private router: Router
	) {
	}

	ngOnInit() {
		this.combSubject = new Subject;
		this.restSub = this.combSubject.combineLatest(this.restProv.list(), (val1, val2) => {
			return val2.filter(item => this.getDistanceFromLatLonInKm(val1.latitude, val1.longitude, item.geo.latitude, item.geo.longitude) <= this.radius);
		}).subscribe(val => {
			this.rests = val;
		});

	  this.route.paramMap
			.subscribe((params: ParamMap) => {
				if(!!this.locations[params.get('loc')]) {
					this.location = this.locations[params.get('loc')]
					this.titleService.setTitle( this.location.name + ' Restaurants | FeastHood');
				} else {
					this.router.navigate(['/']);
				}
				this.radius = this.location.radius;
				this.combSubject.next(this.location.geo);
			});
	}

	ngAfterViewInit() {
	}

	ngOnDestroy() {
		this.titleService.setTitle('FeastHood');
		if (!!this.restSub)
			this.restSub.unsubscribe();
	}

	onSelect(rest: any) {
		this.router.navigate(['/restaurant', rest.uid, rest.key]);
	}

	private getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2): any {
	  let R = 6371; // Radius of the earth in km
  	let dLat = this.deg2rad(lat2-lat1);  // deg2rad below
  	let dLon = this.deg2rad(lon2-lon1); 
  	let a = 
	    Math.sin(dLat/2) * Math.sin(dLat/2) +
	    Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
	    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
	  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
		let d = R * c; // Distance in km
	  return d;
	}

	private deg2rad(deg):any {
	  return deg * (Math.PI/180)
	}
}



// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/pages/location/location.ts